import React, { useEffect } from 'react'
import { BaseNodeProps } from '../../base/types'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { ExternalSendNotificationConfiguration } from './ExternalSendNotificationForm'

//
const ExternalSendNotificationNode = React.memo(
  ({
    data,
    isConnectable,
  }: BaseNodeProps<ExternalSendNotificationConfiguration>) => {
    const title = 'Script'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'filter'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default ExternalSendNotificationNode
